import { FC, ReactElement, ReactNode, useCallback } from 'react';
import * as Sentry from '@sentry/react';
import ErrorCard from '../ErrorCard';

type FallbackProps = {
  resetError: () => void;
};

const FallbackError: FC<FallbackProps> = ({ resetError }) => {
  const onReset = useCallback(() => resetError(), [resetError]);
  return <ErrorCard onRetryClick={onReset} />;
};

const fallBack = (props: FallbackProps) => <FallbackError resetError={props.resetError} />;

type Props = {
  children: ReactNode;
  fallback?: (props: FallbackProps) => ReactElement;
  sentryTags?: Record<string, string>;
};

const ErrorBoundary: FC<Props> = ({ children, fallback = fallBack, sentryTags = undefined }) => {
  const beforeCapture = useCallback(
    (scope: Sentry.Scope) => {
      if (sentryTags) {
        scope.setTags(sentryTags);
      }
    },
    [sentryTags]
  );

  return (
    <Sentry.ErrorBoundary fallback={fallback} beforeCapture={beforeCapture}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
